var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9998 20V30M122.426 37.5736L115.355 44.6447M140 80H130M122.426 122.426L115.355 115.355M79.9998 140V130M37.5734 122.426L44.6445 115.355M20 80H30M37.5734 37.5736L44.6445 44.6447",
    stroke: "url(#paint0_linear_4477_105654)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 77.2376C100 78.8042 99.8127 80.3367 99.4381 81.8353C99.0975 83.3338 98.5526 84.696 97.8033 85.9221C97.0541 87.1141 96.1345 88.0847 95.0447 88.834C93.9549 89.5492 92.6607 89.9068 91.1622 89.9068C89.5956 89.9068 88.3525 89.464 87.433 88.5785C86.5475 87.659 86.0026 86.6203 85.7982 85.4623H85.5428C84.9298 86.7224 84.0272 87.7782 82.8352 88.6296C81.6433 89.4811 80.1447 89.9068 78.3397 89.9068C75.7514 89.9068 73.742 89.0383 72.3116 87.3014C70.9153 85.5645 70.2171 83.2656 70.2171 80.4049C70.2171 78.1571 70.6599 76.1818 71.5453 74.4789C72.4308 72.742 73.6739 71.3797 75.2746 70.3921C76.9093 69.4044 78.8335 68.9106 81.0473 68.9106C82.5458 68.9106 84.0102 69.0468 85.4406 69.3193C86.9051 69.5577 88.046 69.8301 88.8633 70.1367L88.3525 80.507C88.3184 81.1201 88.3014 81.5628 88.3014 81.8353C88.3014 82.0736 88.3014 82.2439 88.3014 82.3461C88.3014 84.1171 88.6079 85.292 89.2209 85.871C89.868 86.45 90.6173 86.7395 91.4687 86.7395C92.5245 86.7395 93.41 86.3138 94.1252 85.4623C94.8744 84.5768 95.4364 83.4189 95.811 81.9885C96.2197 80.5241 96.424 78.9234 96.424 77.1865C96.424 74.0192 95.7769 71.3457 94.4828 69.166C93.2227 66.9523 91.4687 65.2665 89.2209 64.1086C87.0072 62.9506 84.487 62.3716 81.6603 62.3716C78.7654 62.3716 76.1941 62.8314 73.9464 63.751C71.6986 64.6705 69.8084 65.9647 68.2759 67.6335C66.7774 69.3023 65.6364 71.2776 64.8531 73.5594C64.0698 75.8072 63.6782 78.2933 63.6782 81.0179C63.6782 84.3555 64.2742 87.1992 65.4662 89.5492C66.6582 91.8651 68.3951 93.636 70.6769 94.8621C72.9928 96.0541 75.8195 96.6501 79.1571 96.6501C81.2346 96.6501 83.2099 96.4117 85.083 95.9349C86.9902 95.4921 88.676 94.9983 90.1405 94.4534V97.9272C88.676 98.5402 87.0243 99.0341 85.1852 99.4087C83.3802 99.8174 81.3708 100.022 79.1571 100.022C75.1384 100.022 71.6986 99.2725 68.8378 97.7739C65.977 96.2754 63.7803 94.1298 62.2478 91.3372C60.7493 88.5104 60 85.1218 60 81.1711C60 78.0038 60.4938 75.0749 61.4815 72.3844C62.4691 69.6599 63.8995 67.3099 65.7727 65.3346C67.6458 63.3252 69.9106 61.7756 72.5671 60.6858C75.2576 59.5619 78.2886 59 81.6603 59C84.3167 59 86.7518 59.4257 88.9655 60.2771C91.2133 61.0945 93.1545 62.3035 94.7893 63.9042C96.4581 65.4708 97.7352 67.378 98.6207 69.6258C99.5402 71.8736 100 74.4108 100 77.2376ZM74.2018 80.507C74.2018 82.6867 74.6275 84.2703 75.4789 85.258C76.3644 86.2456 77.5394 86.7395 79.0038 86.7395C80.911 86.7395 82.2733 86.0243 83.0907 84.5939C83.9421 83.1635 84.4359 81.3074 84.5722 79.0255L84.8787 72.6398C84.4359 72.5036 83.874 72.3844 83.1928 72.2823C82.5117 72.1801 81.8135 72.129 81.0983 72.129C79.4295 72.129 78.0843 72.5377 77.0626 73.355C76.0409 74.1724 75.3086 75.2282 74.8659 76.5223C74.4232 77.7825 74.2018 79.1107 74.2018 80.507Z",
    fill: "url(#paint1_linear_4477_105654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4477_105654",
    x1: 14.939,
    y1: 94.9105,
    x2: 110.304,
    y2: 161.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A000EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#BF09BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D20FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E1138A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F01776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5196E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4477_105654",
    x1: 58.313,
    y1: 84.608,
    x2: 90.6177,
    y2: 106.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A000EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#BF09BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D20FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E1138A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F01776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5196E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLink);
export default __webpack_public_path__ + "static/media/instagram-link.d61869e80740f13150288281dd611594.svg";
export { ForwardRef as ReactComponent };